import styled from '@emotion/styled'
import { DropdownMenu } from 'components/patterns'

export const Toolbar = styled.div((props) => {
  const {
    theme: {
      color: { slateSecondary },
    },
  } = props
  return `
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 42px;
    background-color: ${slateSecondary};
    display: flex;
    flex-flow: row;
    align-items: center;
    padding-left: 20px;
    box-sizing: border-box;
    user-select: text;
    .ant-slider {
      width: 138px;
      margin: 0px 10px 0 10px;
    }
  `
})

export const PanZoomDropdownMenu = styled(DropdownMenu)((props) => {
  const {
    theme: {
      color: { whitePrimary },
    },
  } = props
  return `
    && {
      .chec-icon--caret_drop_up {
        vertical-align: middle;
      }
      button {
        background: transparent;
        color: ${whitePrimary};
        border: none;
        outline: 0;
        &:hover {
          color: ${whitePrimary};
          border: none;
        }
        &:active {
          color: ${whitePrimary};
          border: none;
        }
        &:focus {
          color: ${whitePrimary};
          border: none;
        }
      }
    }
  `
})

export const ScrollButton = styled.button((props) => {
  const {
    theme: {
      color: { whitePrimary, blueAccent, greySecondary, blackSecondary },
    },
    position,
    disabled,
    offsetRight,
  } = props

  const distance_from_edge = position === 'right' && offsetRight ? 435 : 10
  return `
    z-index: 99;
    position: fixed;
    top: 56.75%;
    ${position}: ${distance_from_edge}px;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    border: none;
    background-color: ${disabled ? greySecondary : whitePrimary};
    cursor: ${disabled ? `not-allowed` : `pointer`};
    box-shadow: 0px 0px 8px rgba(0,0,0,0.3); 
    outline: 0 !important;
    color: ${blackSecondary};
    
    i {
      position: relative;
      ${position}: -1px;
      top: 2px;
    }

    &:hover {
      background-color: ${disabled ? greySecondary : blueAccent};
      
      i {
        color: ${disabled ? blackSecondary : whitePrimary};
        cursor: ${disabled ? `not-allowed` : `pointer`};
      }
    }
  `
})
